function HideShowSkuDetails(updatedSku, updatedBarcode)
{
      //console.log("HideShowSkuDetails called - barcode = "+updatedBarcode);
  //console.log("HideShowSkuDetails called test");
  var blockIdentifier = ".details-sku-variant-block[variantskuvalue='"+updatedSku+"']";
  //console.log("blockIdentifier = " + blockIdentifier);
  $('.details-sku-variant-block').hide();
  $(blockIdentifier).show();

  $(".nw-wtb-display").attr("data-mm-default-id", updatedBarcode); 
  
  //PriceSpider.rebind();
}




